import { render, staticRenderFns } from "./quaCondeperdatFil.vue?vue&type=template&id=dd440504&scoped=true&"
import script from "./quaCondeperdatFil.vue?vue&type=script&lang=js&"
export * from "./quaCondeperdatFil.vue?vue&type=script&lang=js&"
import style0 from "./quaCondeperdatFil.vue?vue&type=style&index=0&id=dd440504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd440504",
  null
  
)

export default component.exports